import { DimensionPrimaryItem } from 'src/components/ImageGenSettings/components/DimensionPrimaryItem';
import styles from './DimensionToggle.module.scss';
import { useUserSettings, useUserSettingsUpdate } from 'src/hooks';
import { SettingKeys, SingleSelectSetting } from 'src/types/settings';
import { ImageSettingsPrimaryGroup } from 'src/constants';

interface DimensionToggleProps {
  selectedValue?: string;
  onChange?: (value: string) => void;
}

export const DimensionToggle = ({
  onChange,
  selectedValue,
}: DimensionToggleProps) => {
  const { setting } = useUserSettings<SingleSelectSetting>(
    SettingKeys.IMAGE_DIMENTIONS,
  );

  const { updateUserSetting } = useUserSettingsUpdate();

  const value = !!selectedValue ? selectedValue : setting?.value || '';

  const handlePrimaryDimensionSelect = (value: string) => {
    if (value !== selectedValue) {
      if (!!onChange) {
        onChange(value);
      } else {
        updateUserSetting({ value, settingKey: SettingKeys.IMAGE_DIMENTIONS });
      }
    }
  };

  return (
    <div className={styles.root}>
      {Object.entries(ImageSettingsPrimaryGroup).map(([key, data]) => (
        <DimensionPrimaryItem
          key={key}
          isSelected={key === value}
          data={{
            ...data,
            name: key,
            isDisabled: Boolean(
              setting?.options &&
                !!setting?.options[key] &&
                !setting?.options[key].selectable,
            ),
          }}
          onClick={() => handlePrimaryDimensionSelect(key)}
        />
      ))}
    </div>
  );
};
